import { render } from "./SplitBanner.vue?vue&type=template&id=6426c175&scoped=true"
import script from "./SplitBanner.vue?vue&type=script&lang=js"
export * from "./SplitBanner.vue?vue&type=script&lang=js"

import "./SplitBanner.vue?vue&type=style&index=0&id=6426c175&scoped=true&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6426c175"]])

export default __exports__